import { useQuery } from '@tanstack/react-query';
import { fetchCatalogs, fetchCategories } from '../services/api';

const STALE_TIME = 5 * 60 * 1000; // 5 minutes - catalogs rarely change

/**
 * Hook to fetch all catalogs
 */
export function useCatalogs() {
  return useQuery({
    queryKey: ['catalogs'],
    queryFn: fetchCatalogs,
    staleTime: STALE_TIME,
  });
}

/**
 * Hook to fetch categories for a catalog
 * @param catalogId - The catalog ID (undefined disables query)
 */
export function useCategories(catalogId: string | undefined) {
  return useQuery({
    queryKey: ['categories', catalogId],
    queryFn: () => fetchCategories(catalogId!),
    staleTime: STALE_TIME,
    enabled: !!catalogId,
  });
}
